import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Component from 'flarum/common/Component';
import Icon from 'flarum/common/components/Icon';
import classList from 'flarum/common/utils/classList';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import batchManager from '../utils/batch-manager';
export default class LinkPreview extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "loading", void 0);
    _defineProperty(this, "link", void 0);
    _defineProperty(this, "linkAttributes", void 0);
    _defineProperty(this, "linkClasses", void 0);
    _defineProperty(this, "data", void 0);
    _defineProperty(this, "useGoogleFavicons", void 0);
    _defineProperty(this, "imageError", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    const attrs = vnode.attrs;
    this.loading = true;
    this.link = attrs.link;
    this.linkAttributes = Object.assign({}, ...Array.from(this.link.attributes, _ref => {
      let {
        name,
        value
      } = _ref;
      return {
        [name]: value
      };
    }));
    this.linkClasses = (this.linkAttributes.class || '').replace(/\bLinkPreview-captured\b/g, '').trim();
    this.linkAttributes.target = attrs.openLinksInNewTab ? '_blank' : '_self';
    delete this.linkAttributes.class;
    delete this.linkAttributes.style;
    this.data = null;
    this.useGoogleFavicons = attrs.useGoogleFavicons;
    this.imageError = false;
    this.fetchData();
  }
  view() {
    var _this$data;
    if (this.loading) {
      return this.viewLoading();
    }
    if ((_this$data = this.data) != null && _this$data.error) {
      return this.viewError();
    }
    return this.viewLoaded();
  }
  viewLoading() {
    return m("div", {
      className: classList('LinkPreview', 'LinkPreview--loading')
    }, m("div", {
      className: "LinkPreview-image"
    }, m(LoadingIndicator, {
      display: "unset",
      size: "small"
    })), m("div", {
      className: "LinkPreview-main"
    }, m("div", {
      className: "LinkPreview-title"
    }, this.getLink(this.getDomain())), m("div", {
      className: "LinkPreview-domain"
    }, this.useGoogleFavicons ? m("img", {
      src: this.getFavicon(),
      alt: ""
    }) : m(Icon, {
      name: "fas fa-external-link-alt"
    }), this.getLink(this.getDomain()))));
  }
  viewError() {
    return m("div", {
      className: classList('LinkPreview', 'LinkPreview--error')
    }, m("div", {
      className: "LinkPreview-main"
    }, m("div", {
      className: "LinkPreview-title"
    }, this.getLink(this.getDomain())), m("div", {
      className: "LinkPreview-description LinkPreview-description--error"
    }, this.data.error), m("div", {
      className: "LinkPreview-domain"
    }, this.useGoogleFavicons ? m("img", {
      src: this.getFavicon(),
      alt: ""
    }) : m(Icon, {
      name: "fas fa-external-link-alt"
    }), this.getLink(this.getDomain()))));
  }
  viewLoaded() {
    var _this$data2, _this$data$title, _this$data3, _this$data$site_name, _this$data4;
    const image = this.getImage();
    const showImage = image && !this.imageError;
    const description = (_this$data2 = this.data) == null ? void 0 : _this$data2.description;
    return m("div", {
      className: classList('LinkPreview', 'LinkPreview--loaded')
    }, showImage ? m("div", {
      className: "LinkPreview-image"
    }, m("img", {
      src: image,
      alt: "",
      loading: "lazy",
      onError: () => {
        this.imageError = true;
        m.redraw();
      }
    })) : null, m("div", {
      className: "LinkPreview-main"
    }, m("div", {
      className: "LinkPreview-title"
    }, this.getLink((_this$data$title = (_this$data3 = this.data) == null ? void 0 : _this$data3.title) != null ? _this$data$title : this.getDomain())), description ? m("div", {
      className: "LinkPreview-description"
    }, description) : null, m("div", {
      className: "LinkPreview-domain"
    }, this.useGoogleFavicons ? m("img", {
      src: this.getFavicon(),
      alt: ""
    }) : m(Icon, {
      name: "fas fa-external-link-alt"
    }), this.getLink((_this$data$site_name = (_this$data4 = this.data) == null ? void 0 : _this$data4.site_name) != null ? _this$data$site_name : this.getDomain()))));
  }
  getLink(text) {
    return m("a", Object.assign({}, this.linkAttributes, {
      className: classList('LinkPreview-link', this.linkClasses)
    }), text != null ? text : this.getDomain());
  }
  getHref() {
    return this.link.href;
  }
  getDomain() {
    return this.getHref().split('/')[2];
  }
  getImage() {
    var _this$data5;
    return ((_this$data5 = this.data) == null ? void 0 : _this$data5.image) || null;
  }
  getFavicon() {
    return this.useGoogleFavicons ? "https://www.google.com/s2/favicons?sz=64&domain_url=".concat(this.getDomain()) : null;
  }
  fetchData() {
    batchManager.add(this.getHref(), data => {
      this.data = data;
      this.loading = false;
      m.redraw();
    });
  }
}
flarum.reg.add('datlechin-link-preview', 'forum/components/LinkPreview', LinkPreview);